import { call, takeLatest } from "redux-saga/effects";
import * as orderApis from "../apis/orderApis"
import { CREATE_ORDER, APPROVE_REJECT_ORDER, EDIT_ORDER, LIST_ORDER, VIEW_ORDER } from "../actions/types";


export function* createOrderWorker(action) {
    try {
        const res = yield call(orderApis.createOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editOrderWorker(action) {
    try {
        const res = yield call(orderApis.editOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* approveRejectOrderWorker(action) {
    try {
        const res = yield call(orderApis.approveRejectOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* listOrderWorker(action) {
    try {
        const res = yield call(orderApis.listOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewOrderWorker(action) {
    try {
        const res = yield call(orderApis.viewOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher Func */
export function* createOrderWatcher() {
    yield takeLatest(CREATE_ORDER, createOrderWorker);
}
export function* editOrderWatcher() {
    yield takeLatest(EDIT_ORDER, editOrderWorker);
}
export function* approveRejectOrderWatcher() {
    yield takeLatest(APPROVE_REJECT_ORDER, approveRejectOrderWorker);
}
export function* listOrderWatcher() {
    yield takeLatest(LIST_ORDER, listOrderWorker);
}
export function* viewOrderWatcher() {
    yield takeLatest(VIEW_ORDER, viewOrderWorker);
}